import { getDatabase, ref, update } from "firebase/database";

const db = getDatabase();

export const deleteOfferFromFirebase = async ({
	offerId,
	shopId,
	category,
	subCategory,
	geoHash,
}) => {
	try {
		/* ================= MULTI LOCATION DELETE ================= */
		const updates = {};
		updates[`offers/byShop/${shopId}/${offerId}`] = null;
		updates[`offers/byGeoHash/${geoHash}/${offerId}`] = null;

		// const cleanCategory = category.toLowerCase().replace(/\s+/g, "_");

		// const cleanSubCategory = subCategory
		// 	? subCategory.toLowerCase().replace(/\s+/g, "_")
		// 	: "all";

		// updates[`offers/allOffers/${offerId}`] = null;

		// updates[
		// 	`offers/byCategory/${cleanCategory}/${cleanSubCategory}/${offerId}`
		// ] = null;

		// updates[`offers/byCategory/${cleanCategory}/all/${offerId}`] = null;

		// updates[`offers/activeOffers/${offerId}`] = null;

		/* ================= SINGLE API CALL ================= */

		await update(ref(db), updates);

		return {
			success: true,
			message: "Offer deleted successfully",
		};
	} catch (error) {
		console.error(error);
		throw error;
	}
};
